import { render, staticRenderFns } from "./DialogFreePackage.vue?vue&type=template&id=fc33d8a4&scoped=true"
import script from "./DialogFreePackage.vue?vue&type=script&lang=js"
export * from "./DialogFreePackage.vue?vue&type=script&lang=js"
import style0 from "./DialogFreePackage.vue?vue&type=style&index=0&id=fc33d8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc33d8a4",
  null
  
)

export default component.exports